import styled from "styled-components";
import { Icons } from "../../utils/react-svg";

const Container = styled.div`
  margin-top: var(--spacing-0_5);
  margin-bottom: var(--spacing-1_5);
  display: flex;
  gap: var(--spacing-1, 16px);
  align-items: flex-start;
`;

const IconWrapper = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  padding-top: 2px;

  svg {
    width: 18px;
    height: 18px;

    path {
      fill: var(--indigo-blue-60, #62719f);
    }
  }
`;

const WarningContent = styled.div`
  flex: 1;
`;

const WarningText = styled.p`
  margin: 0;
  color: var(--indigo-blue-60, #62719f);
  line-height: 1.5;

  a {
    color: var(--indigo-blue-60, #62719f);
    text-decoration: underline;
  }
`;

const WarningTitle = styled.strong`
  display: block;
  margin-bottom: var(--spacing-0_25);
  color: var(--indigo-blue-60, #62719f);
`;

const Prop65Warning = () => {
  return (
    <Container className="typography-caption" data-testid="prop65-warning">
      <IconWrapper>
        <Icons.AlertWarning />
      </IconWrapper>
      <WarningContent>
        <WarningText>
          <WarningTitle>CA Prop 65 Warning</WarningTitle>
          One or more of these products may expose you to lead, which is known
          to the State of California to cause cancer or reproductive harm. For
          more information, visit{" "}
          <a
            href="https://www.p65warnings.ca.gov"
            target="_blank"
            rel="noopener noreferrer"
          >
            P65Warnings.ca.gov
          </a>
          .
        </WarningText>
      </WarningContent>
    </Container>
  );
};

export default Prop65Warning;
